import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Invite',
        component: () => import('../components/invite.vue'),
    },
    {
        path: '/invite/:id',
        name: 'InviteId',
        component: () => import('../components/invite.vue'),
    },
    {
        path: '/training',
        name: 'Training',
        component: () => import('../components/training.vue')
    },
    {
        path: '/result',
        name: 'Result',
        component: () => import('../components/result.vue')
    },
    {
        path: '/error',
        name: 'Error',
        component: () => import('../components/error.vue')
    },
    {
        path: '*',
        name: '404',
        component: () => import('../components/error.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router
